/**
 * c-logos.js — ブランド一覧スライダー
 * 依存なし（Vanilla JS）
 */
(function () {
  'use strict';

  class LogosSlider {
    constructor(container) {
      this.container = container;
      this.currentIndex = 0;

      this.slides    = Array.from(container.querySelectorAll('[data-logos-slide]'));
      this.infoItems = Array.from(container.querySelectorAll('[data-logos-info-item]'));
      this.thumbs    = Array.from(container.querySelectorAll('[data-logos-thumb]'));
      this.prevBtn   = container.querySelector('[data-logos-prev]');
      this.nextBtn   = container.querySelector('[data-logos-next]');

      if (this.slides.length === 0) return;

      this.bindEvents();
      this._initializing = true;
      this.goTo(0);
      this._initializing = false;
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.navigate(-1, { userTriggered: true }));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.navigate(1, { userTriggered: true }));
      }

      this.thumbs.forEach((thumb, i) => {
        thumb.addEventListener('click', () => this.goTo(i, { userTriggered: true }));
      });
    }

    navigate(direction, options) {
      const len = this.slides.length;
      this.goTo(((this.currentIndex + direction) % len + len) % len, options);
    }

    goTo(index, options) {
      options = options || {};
      this.currentIndex = index;

      this.slides.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
      });

      this.infoItems.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
      });

      this.thumbs.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
        el.setAttribute('aria-pressed', String(i === index));
      });

      /* アクティブサムネイルをスクロールして見えるようにする（初期化時はスキップ） */
      const activeThumb = this.thumbs[index];
      if (activeThumb && !this._initializing) {
        activeThumb.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }

      if (options.userTriggered && !this._initializing) {
        this._scrollToTargetIfNeeded();
        this._pulseThumb(activeThumb);
      }
    }

    _scrollToTargetIfNeeded() {
      const selector = this.container.dataset.logosScrollTarget;
      if (!selector) return;
      const target = this.container.querySelector(selector);
      if (!target) return;

      const rect = target.getBoundingClientRect();
      const headerOffset = this._getStickyHeaderOffset();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      /* ターゲット上端がヘッダー直下〜画面中央にあれば既に見えている → 何もしない */
      if (rect.top >= headerOffset && rect.top < viewportHeight * 0.6) return;

      const targetY = window.scrollY + rect.top - headerOffset - 16;
      window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
    }

    _getStickyHeaderOffset() {
      const header = document.getElementById('HeaderWrapper');
      if (!header) return 0;
      const rect = header.getBoundingClientRect();
      /* 画面上部に張り付いて見えている場合のみオフセットとして扱う */
      if (rect.top <= 0 && rect.bottom > 0) return rect.bottom;
      return 0;
    }

    _pulseThumb(el) {
      if (!el) return;
      el.classList.remove('is-tapped');
      void el.offsetWidth; /* reflow で再アニメーションを可能にする */
      el.classList.add('is-tapped');
      window.setTimeout(() => el.classList.remove('is-tapped'), 400);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-logos-container]').forEach(function (el) {
      if (!el._logosSlider) {
        el._logosSlider = new LogosSlider(el);
      }
    });
  }

  /* DOM 準備済みか確認してから初期化 */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify テーマエディター: セクション再読み込み時に再初期化 */
  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector('[data-logos-container]');
    if (container) {
      container._logosSlider = null;
      container._logosSlider = new LogosSlider(container);
    }
  });
})();
